import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { IoClose } from "react-icons/io5";

const affiliateImages = [
  "/1.jpg",
  "/2.jpg",
  "/3.jpg",
  "/4.jpg",
  "/5.jpg",
  "/6.jpg",
  "/7.jpg",
  "/8.jpg",
  "/9.jpg",
  "/10.jpg",
  "/11.jpg",
  "/13.jpg",
  "/14.jpg",
  "/15.jpg",
  "/16.jpg",
];

const MsportModal = ({ setShowModal }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);

  useEffect(() => {
    // pick a random affiliate image on mount
    const rand =
      affiliateImages[Math.floor(Math.random() * affiliateImages.length)];
    setSelectedImage(rand);

    // lock scroll: preserve current scroll position then fix body
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const prevStyle = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      overflow: document.body.style.overflow,
      paddingRight: document.body.style.paddingRight,
    };

    // compensate for scrollbar to avoid layout shift
    const scrollBarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    if (scrollBarWidth > 0) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";

    // prevent touchmove on mobile
    const preventTouch = (e) => e.preventDefault();
    document.addEventListener("touchmove", preventTouch, { passive: false });

    return () => {
      // restore styles and scroll position
      document.body.style.position = prevStyle.position || "";
      document.body.style.top = prevStyle.top || "";
      document.body.style.left = prevStyle.left || "";
      document.body.style.right = prevStyle.right || "";
      document.body.style.overflow = prevStyle.overflow || "";
      document.body.style.paddingRight = prevStyle.paddingRight || "";

      window.scrollTo(0, scrollY);
      document.removeEventListener("touchmove", preventTouch);
    };
  }, []);

  return (
    <div className="msport-modal" role="dialog" aria-modal="true">
      <div className="m_m_container">
        <h2>LET'S WIN TOGETHER</h2>
        <hr />
        <NavLink to={"https://1wtauc.com/?p=uok3"}>
          <div
            style={{
              width: "100%",
              maxWidth: 760,
              minHeight: 220,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(0,0,0,0.03)",
              borderRadius: 0,
            }}
          >
            {!imgLoaded && (
              <div
                aria-hidden
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  border: "4px solid rgba(255,255,255,0.08)",
                  borderTopColor: "var(--clr-primary-1, #009578)",
                  animation: "spin 0.9s linear infinite",
                }}
              />
            )}
            <img
              src={selectedImage ? `/a_images${selectedImage}` : "/ms.jpg"}
              alt="free bet"
              onLoad={() => setImgLoaded(true)}
              onError={() => {
                setImgLoaded(true); // stop spinner on error, browser will show alt
              }}
              style={{
                borderRadius: 0,
                width: "100%",
                display: imgLoaded ? "block" : "none",
              }}
            />
          </div>
        </NavLink>
        <hr />

        <NavLink to={"https://1wtauc.com/?p=uok3"}>
          <button>Join Now</button>
        </NavLink>

        <div
          onClick={() => setShowModal(false)}
          style={{
            backgroundColor: "#fff",
            color: "#009578",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "1rem",
            padding: ".5rem",
            position: "absolute",
            top: 0,
            right: 0,
            cursor: "pointer",
          }}
        >
          <IoClose size={25} />
        </div>
      </div>
    </div>
  );
};

export default MsportModal;
